import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import BookingTable, { COLUMNS, CARDS, MIN_TABLE_WIDTH } from 'components/Tables/Booking';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from './bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'bookingStore') @observer
class BookingsIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      bookingStore,
      bookingStore: {
        bookings: {
          isLoading,
          isError
        }
      },store, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading columns={COLUMNS} cards={CARDS} minTableWidth={MIN_TABLE_WIDTH} noun="bookings" />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="bookings" onRetry={() => bookingStore.loadBookings()} />;
    }
    if (!isError && !isLoading) {
      content = <BookingTable />
    }
    return (
      <div>
        <Helmet>
          <title>Bookings | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.BookingSearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default BookingsIndexPage;